export const decimalToAmerican = (decimalOdds: number): string => {
    // Decimal odds less than 1 are not valid
    if (decimalOdds < 1) {
        return 'Invalid odds';  
    }

    // For decimal odds of 2.0 or higher, subtract 1 and then multiply by 100
    // For decimal odds less than 2.0, calculate the negative American odds
    // Round the result to avoid decimal places in American odds
    const americanOdds = decimalOdds >= 2.0 ? (decimalOdds - 1) * 100 : decimalOdds > 1.0 ? -100 / (decimalOdds - 1) : 0;
    
    return americanOdds >= 0 ? `+${Math.round(americanOdds)}` : `${Math.round(americanOdds)}`;
};
